interface IconProps {
  className?: string
}

function TikTokIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M15.73 3c.2 1.68 1.15 3.16 2.58 4.05A8.03 8.03 0 0 0 21 8v3.2a11.08 11.08 0 0 1-5.27-1.34v6.6a5.73 5.73 0 1 1-4.94-5.67v3.26a2.57 2.57 0 1 0 1.72 2.42V3h3.22Z"
      />
    </svg>
  )
}

function InstagramIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        x="3.25"
        y="3.25"
        width="17.5"
        height="17.5"
        rx="4.75"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle
        cx="12"
        cy="12"
        r="4.15"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <circle cx="17.65" cy="6.65" r="1.1" fill="currentColor" />
    </svg>
  )
}

function XIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M18.73 3h2.94l-6.42 7.34L22.8 21h-5.91l-4.63-6.05L6.97 21H4.02l6.86-7.84L3.63 3h6.06l4.19 5.54L18.73 3Zm-1.03 16.12h1.63L8.8 4.78H7.05L17.7 19.12Z"
      />
    </svg>
  )
}

function EmailIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4.25 6.25h15.5v11.5H4.25z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
      <path
        d="m4.75 7 7.25 5.5L19.25 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SocialContactRail() {
  return (
    <nav className="social-contact-rail" aria-label="Social and contact links">
      <a
        className="social-contact-rail__link"
        href="https://www.tiktok.com/@iftat_"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow Iftat Bhuiyan on TikTok"
        title="TikTok"
      >
        <TikTokIcon className="social-contact-rail__icon" />
      </a>
      <a
        className="social-contact-rail__link"
        href="https://www.instagram.com/iftatbhuiyan/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow Iftat Bhuiyan on Instagram"
        title="Instagram"
      >
        <InstagramIcon className="social-contact-rail__icon" />
      </a>
      <a
        className="social-contact-rail__link"
        href="https://x.com/IftatBhuiyan"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow Iftat Bhuiyan on X"
        title="X"
      >
        <XIcon className="social-contact-rail__icon" />
      </a>
      <a
        className="social-contact-rail__link social-contact-rail__link--contact"
        href="mailto:iftatbhuiyan100@gmail.com"
        aria-label="Email Iftat Bhuiyan"
        title="Email Iftat Bhuiyan"
      >
        <EmailIcon className="social-contact-rail__icon" />
        <span className="social-contact-rail__contact-label">Contact</span>
      </a>
    </nav>
  )
}
